// Match MCP identifier length/characters, while excluding URL dot segments.
export function isPlaybackIdentifier(id: string | null): id is string {
  return Boolean(
    id && id.length <= 200 && id.trim() === id && /^[^/\\]+$/.test(id) && id !== '.' && id !== '..',
  );
}
